require('./bootstrap')

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

import './helpers'

// Create VueI18n instance with options
import messages from './messages'
window.i18n = new VueI18n({
  locale: 'th',
  fallbackLocale: 'en',
  messages,
  silentTranslationWarn: false
})


import VeeValidate from 'vee-validate'
import messagesValidation from './messages-validation'

Vue.use(VeeValidate, {
  locale: 'th',
  // locale: tempLange,
  dictionary: messagesValidation
})

// require('jquery-validation')
// require('./helpers')

require('./pages/auth')
